import { render, staticRenderFns } from "./Lgx02828126365964484739193.vue?vue&type=template&id=2f9b6608&"
import script from "./Lgx02828126365964484739193.vue?vue&type=script&lang=js&"
export * from "./Lgx02828126365964484739193.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02828126365964484739193.vue?vue&type=style&index=0&id=2f9b6608&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports